module.exports = __webpack_public_path__ + "static/Banner-27-f6190b2b337367c0551f93d83b292b6b.png";